import React, { useState } from 'react'

export default function Pagination({ postPerPage, totalPost, paginate }) {


    const pageNumber = [];

    const [paginates, setPaginates] = useState(1)


    const indexOfLastPost = paginates * postPerPage;
    const indexOfFirstPost = indexOfLastPost - postPerPage;

    console.log(postPerPage, paginates, indexOfFirstPost, indexOfLastPost);
    for (let i = 1; i <= Math.ceil(totalPost / postPerPage); i++) {
        pageNumber.push(i);
    }

    const paginationHandle = (number) => {
        setPaginates(number)
        paginate(number)
    }



    return (
        <nav aria-label="Page navigation example">
            <ul className='inline-flex items-center -space-x-px'>
                <li>
                    <a onClick={() => paginate(paginates == 1 ? 1 : paginates - 1)} className="block px-3 py-2 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-blue hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                        <span className="sr-only">Previous</span>
                        <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"></path></svg>
                    </a>
                </li>
                {pageNumber.map(number => (
                    <li key={number}>
                        <a onClick={() => paginationHandle(number)} className='px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-blue hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white cursor-pointer' >
                            {number}
                        </a>
                    </li>
                ))
                }
                <li>
                    <a onClick={() => paginate(paginates == indexOfFirstPost ? indexOfFirstPost : paginates + 1)} className="block px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-blue hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                        <span className="sr-only">Next</span>
                        <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg>
                    </a>
                </li>
            </ul>
        </nav>
    )
}